// Keeps signup attribution out of URLs so Google never crawls ?src= duplicate pages.
export const rememberSource = (src) => () => {
  try { sessionStorage.setItem('wts_signup_source', src); } catch (e) { /* storage blocked */ }
};
